import { gql } from "apollo-boost"

export const CHECK_TRUSTED_DEVICE = gql`
  query checkTrustedDevice($deviceId: String!) {
    checkTrustedDevice(deviceId: $deviceId) {
      deviceStatus
      requireConfirmation
    }
  }
`